import ScrollCarousel from '../../components/ScrollCarousel';

// Make an index of carousels for potential use later in theme editor
const carousels = {};
const carousels_mobile = {};

// `.HeroCarousel .HeroSlide` starts at `opacity: 0` and only becomes visible
// once the carousel is marked enabled — this used to be Flickity's runtime
// `flickity-enabled` class. Apply it on every path, including the bails, or a
// single-slide hero renders blank.
const ENABLED_CLASS = 'HeroCarousel--enabled';

const SELECTORS = {
  viewport: '[data-hero-carousel-viewport]',
  track: '[data-hero-carousel-track]',
};

const CLASSES = {
  viewport: 'HeroCarousel__viewport',
  track: 'HeroCarousel__track',
  arrow: 'HeroCarousel__arrow',
  arrowPrev: 'HeroCarousel__arrow--previous',
  arrowNext: 'HeroCarousel__arrow--next',
  arrowDisabled: 'HeroCarousel__arrow--disabled',
  dots: 'HeroCarousel__dots',
  dot: 'HeroCarousel__dot',
  dotActive: 'HeroCarousel__dot--active',
  pause: 'HeroCarousel__pause',
};

// The main function that actually initializes the carousels
const carouselInit = (section_id, carousel, index) => {
  if (!carousel) {
    return;
  }

  carousel.classList.add(ENABLED_CLASS);

  const track = carousel.querySelector(SELECTORS.track);
  // Fall back to the carousel element so a mis-wired section still reports a
  // sane slide count instead of throwing.
  const slide_count = (track || carousel).children.length;

  if (slide_count < 2) {
    // Don't init pointless carousels with no slides
    return;
  }

  let object = carousels;
  if (carousel.id.indexOf('mobile') >= 0) {
    object = carousels_mobile;
  }

  const data = carousel.dataset;

  object[section_id] = new ScrollCarousel(carousel, {
    selectors: SELECTORS,
    classes: CLASSES,
    initialIndex: index || 0,
    prevNextButtons: data.prevNextButtons === 'true',
    pageDots: data.pageDots === 'true',
    loop: data.wrapAround === 'true',
    // Hero autoplay is deliberately hard-coded OFF.
    //
    // The Liquid emits `data-auto-play` as either a millisecond number or the
    // literal string "false". The previous Flickity call site tested
    // `data.autoPlay === 'true'`, which a numeric string never matches, so
    // hero autoplay has been dead in production for as long as this code has
    // existed. Wiring the value through correctly would silently switch
    // autoplay ON storefront-wide across full-viewport hero units — a visible
    // behavior change that needs a PM decision, not a code decision. Do not
    // "fix" this without that sign-off. Ref. WIN-8070.
    autoPlay: 0,
    adaptiveHeight: true,
    draggable: data.draggable === 'true',
    slidesPerView: 1,
    ariaLabel: 'Hero carousel',
    on: {
      change: () => {
        // This is now called 'heroCarouselDidChange' but leaving the old name for backwards-compatability
        const event1 = new CustomEvent('heroCarouselChange', { detail: section_id });
        document.dispatchEvent(event1);
        const event2 = new CustomEvent('heroCarouselDidChange', { detail: section_id });
        document.dispatchEvent(event2);
      },
    },
  });
};

export { carousels, carousels_mobile, carouselInit };
